<template>
	<form class="check_multiple_send" :inert="isLoading" :class="{ 'ajax_processed': isLoading }" @submit.prevent="onSubmit">
		<div class="form_row required" :class="{ 'error': v$.formData.name.$errors.length }">
			<label for="add-review-name">Имя<span class="req">*</span></label>
			<input id="add-review-name" type="text" v-model="formData.name">
		</div>
		<div class="form_row required" :class="{ 'error': v$.formData.email.$errors.length }">
			<label for="add-review-email">E-mail<span class="req">*</span></label>
			<input id="add-review-email" type="email" v-model="formData.email">
		</div>
		<div class="form_row required" :class="{ 'error': v$.formData.comment.$errors.length }">
			<label for="add-review-comment">Комментарий <span class="req">*</span></label>
			<textarea id="add-review-comment" v-model="formData.comment"></textarea>
		</div>
		<div class="consent-accepted" v-if="confirmConsent">Согласие на обработку персональных данных принято</div>
	
		<div v-if="!confirmConsent" class="confirm-consent">
			<div class="confirm-consent__text">
				Подтвердите <a href="/upload/Согласие.pdf" target="_blank">согласие</a> на обработку <br> Ваших персональных данных
			</div>
			<div class="confirm-consent__btn">
				<button class="btn btn_red" type="button" @click="confirmConsent = true">Подтвердить</button>
			</div>
		</div>
		<div v-else class="consent-block">
			<div class="consent-final">
				<div class="consent-final__text">
					Нажимая кнопку, Вы подтверждаете, что ознакомились с <a href="/upload/Политикa-конфиденциальности.pdf" target="_blank">Политикой конфиденциальности</a>
				</div>
				<div class="consent-final__btn">
					<div class="not-theme">
						<button class="btn btn_red">Отправить</button>
					</div>
				</div>
			</div>
		</div>
	</form>
	</template>
	
	<script>
	import { mapActions, mapGetters } from 'vuex';
	import { useVuelidate } from '@vuelidate/core'
	import { required, email, helpers, minLength } from '@vuelidate/validators'
	
	const { withMessage } = helpers;
	import { objectToFormData } from '../../utils/objectToFormData.js';
	import initMasks from '../../utils/masks.js';
	
	export default {
		name: 'RenterForm',
		props: {
			newsId: {
				type: Number,
				required: true,
				default: 0,
			},
		},
		setup() {
			return { v$: useVuelidate(), initMasks }
		},
		data: () => ({
			formData: {
				name: '',
				email: '',
				comment: '',
				newsId: 0,
			},
			isLoading: false,
			confirmConsent: false,
		}),
		validations() {
			return {
				formData: {
					name: {
						required: withMessage('Обязательное поле', required)
					},
					email: {
						required: withMessage('Обязательное поле', required),
						email: withMessage('Введите корректный email', email),
					},
					comment: {
						required: withMessage('Обязательное поле', required),
						minLength: withMessage('Отзыв должен быть не менее 5 символов', minLength(5)),
					},
				}
			}
		},
		mounted() {
			this.initMasks();
		},
		computed: {
			...mapGetters({
				getYandexSiteKey: 'getYandexSiteKey',
			})
		},
		watch: {},
		methods: {
			async onSubmit() {
				const isValid = await this.v$.$validate();
				if (!isValid) return
				this.isLoading = true;
				const isCaptchaStarted = await this.executeYandexCaptcha(() => this.sendForm());
				if (!isCaptchaStarted) {
					this.isLoading = false;
					window.showHeaderMessage('Не удалось загрузить проверку. Перезагрузите страницу и попробуйте ещё раз.', 'error');
				}
			},
			clearForm() {
				this.v$.$reset();
				this.formData = {
					name: '',
					email: '',
					comment: '',
					newsId: 0,
				};
			},
			async sendForm() {
				try {
					this.formData.newsId = this.newsId;
					const result = await fetch('/api/forms/add-review-news/', {
						method: 'POST',
						body: objectToFormData({ ...this.formData, yatoken: window.smartCaptcha.getResponse() }),
					});
					const data = await result.json();
					if (data.success) {
						window.showHeaderMessage('Ваш отзыв отправлен');
						this.clearForm();
					} else {
						window.showHeaderMessage(data.error || 'Произошла ошибка', 'error');
					}
				} catch (error) {
					window.showHeaderMessage(error || 'Произошла ошибка', 'error');
				} finally {
					this.isLoading = false;
				}
			},
			...mapActions({
				'executeYandexCaptcha': 'executeYandexCaptcha',
			}),
		},
	}
</script>
